import { useEffect } from "react";

function useScrollToTop(isLoaded) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoaded]);
}

export default useScrollToTop;
